export default __webpack_public_path__ + "static/media/higher_primary_logo_url_reversed.7a079a57.svg";